import { createContext } from "react";

type DateInputContextValue = {
  dayDescribedBy: string;
  monthDescribedBy: string;
  yearDescribedBy: string;
};

const DateInputContext = createContext<DateInputContextValue>(
  {} as DateInputContextValue
);

export default DateInputContext;
